import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, retry } from 'rxjs';
import { MainService } from 'src/app/app.service';

@Injectable({
  providedIn: 'root'
})
export class DatabaseService {

  constructor(private _http: HttpClient, private mainService: MainService) { }

    getDatabases (): Observable<any> {
      let databases = this._http.get('/api/v2/databases/complete', this.mainService.httpOptions).pipe(
          retry(3),
          map(instancias => {
             return instancias;
          }),
          catchError(this.mainService.handleError)
      );

      return new Observable((subscriber) => {
        databases.subscribe((data) => {
          let data2 = data as Array<{kind?: string}>;
          for (const i of data2) i.kind = 'database';
          subscriber.next(data2);
        });
      });
    }

    // REMOVE: usado no painel de admin, talvez trocar para o v2?
    getAllDatabases (): Observable<any> {
        return this._http.get('/api/v1/resources?view=all', this.mainService.httpOptions )
                .pipe(
                        retry(3),
                        map(instancias => {
                            return instancias;
                        }),
                        catchError(this.mainService.handleError));
    }

    getRecipes(): Observable<any> {
      let templates = this._http.get(`/api/v2/templates`, this.mainService.httpOptions ).pipe(
        retry(3),
        map(data => {
          return data;
        }),
        catchError(this.mainService.handleError)
      );

      return new Observable((subscriber) => {
        templates.subscribe((data) => {
          let data2 = data as Array<{kind?: string}>;
          for (let item of data2) item.kind = "template";
          subscriber.next(data2);
        });
      });
    }

    getRegions(): Observable<any> {
        return this._http.get('/api/v2/regions', this.mainService.httpOptions)
            .pipe(
                retry(3),
                map(regions => {
                    return regions;
                }),
                catchError(this.mainService.handleError));
    }

    createDatabase2(name, templateId, filename, region_id, tags) {
        let bucket = (filename) ? this.mainService.userToken.username : '';

        let payload = JSON.stringify({
            name,
            templateId,
            bucket,
            filename,
            region_id,
            tags
        });

        return this._http.post('/api/v2/databases', payload, this.mainService.httpOptions).pipe(
            map(res => {
                return res;
            }),
            catchError(this.mainService.handleError)
        );
    }

    getDatabaseName(id: string, resources: Array<any>) {
        let instIndex;
        let instName;
        instIndex = resources.find(obj => obj.Id === id);
        instIndex = resources.indexOf(instIndex);

        if ( instIndex > -1 ) {
            instName = resources[instIndex].Name;
        } else {
            instName = 'NOT FOUND';
        }
        return instName;
    }

    deleteDatabase2 (id): Observable<any> {
        return this._http.delete(`/api/v2/databases/${id}`, this.mainService.httpOptions)
        .pipe(map(res => {
            return res;
        }),
            catchError(this.mainService.handleError)
        );
    }

    alterarDatabase2(id, name, expirationDays): Observable<any> {
        this.mainService.updateHeaders();

        return this._http.put('/api/v2/databases/' + id, JSON.stringify({name, expirationDays}), this.mainService.httpOptions)
            .pipe(
                map( res => {
                    return res;
                }),
                    catchError(this.mainService.handleError)
            );
    }

    getActionsbyResource (resourceId): Observable<any> {
        return this._http.get('/api/v1/actions?resourceId=' + resourceId, this.mainService.httpOptions )
                    .pipe(
                            retry(3),
                            map(actions => {
                                return actions;
                            }),
                            catchError(this.mainService.handleError));
    }

    restartDbAccess2 (id): Observable<any> {
        return this._http.post(`/api/v2/databases/${id}/restart/`, JSON.stringify({ id }), this.mainService.httpOptions)
            .pipe(
                map(res => {
                    return res;
            }),
                catchError(this.mainService.handleError)
            );
    }

    backupDatabase2(id): Observable<any> {
        return this._http.post(`/api/v2/databases/${id}/backup`, JSON.stringify({ id }), this.mainService.httpOptions)
            .pipe(
                map(res => {
                    return res;
            }),
                catchError(this.mainService.handleError)
            );
    }

    restoreDatabase2(id, filename): Observable<any> {
        return this._http.post(`/api/v2/databases/${id}/restore` , JSON.stringify({ id, filename }), this.mainService.httpOptions)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.mainService.handleError)
            );
    }

    shareDatabase2(id, shareList): Observable<any> {
        return this._http.put(`/api/v2/databases/${id}/share`, JSON.stringify({ shareList }), this.mainService.httpOptions)
            .pipe(
                map(res => {
                    return res;
                }),
                catchError(this.mainService.handleError)
            );
    }

    changePasswordDatabase2 (id, pass): Observable<any> {
        this.mainService.updateHeaders();

        return this._http.put(`/api/v2/databases/${id}/password/`, JSON.stringify({id, pass}), this.mainService.httpOptions)
            .pipe(
                map( res => {
                    return res;
                }),
                    catchError(this.mainService.handleError)
            );
    }

    public uploadImage(file: File, filename: string): Observable<any> {

        const formData = new FormData();
        const httpOptions = {
            headers : new HttpHeaders ({
                'Authorization': this.mainService.userToken.token
                })
            };
        formData.append('file', file);

        return this._http.post('/api/v1/files?filename=' + filename, formData, httpOptions)
            .pipe(
                map(res => {
                    return res;
            }),
                catchError(this.mainService.handleError)
            );
    }

    public getFiles (): Observable<any> {
        return this._http.get('/api/v1/files', this.mainService.httpOptions )
                    .pipe(
                            retry(3),
                            map(files => {
                                return files;
                            }),
                            catchError(this.mainService.handleError));
    }

    public deleteFile (name): Observable<any> {
        return this._http.delete('/api/v1/files/' + name, this.mainService.httpOptions)
        .pipe(
            catchError(this.mainService.handleError)
        );
    }

    public downloadFile (name): Observable<any> {

        return this._http.get('/api/v1/files/url/' + name , this.mainService.httpOptions)
                .pipe(
                    retry(3),
                    map(files => {
                        return files;
                    }),
                    catchError(this.mainService.handleError));
    }

}
